<template>
  <div>
    <base-title
      title="Google Ads"
      :subtitle="StringLanguage.integrations"
      link="integracoes"
    />

    <div class="integration-details">
      <div class="header">
        <div class="wrapper">
          <p class="title">Sobre o Google Ads</p>
          <img
            src="@/assets/img/integration.svg"
            class="img-fluid mobile"
            alt="Integrações"
          />
          <p class="description">
            O Google Ads é a plataforma de anúncios do Google. Através do Google
            Ads, é possível criar anúncios de pesquisa, de display, no Youtube,
            no Gmail e na Play Store.
          </p>
        </div>
        <img
          src="@/assets/img/integration.svg"
          class="img-fluid desktop"
          alt="Integrações"
        />
      </div>

      <div class="register">
        <base-button
          text="Cadastrar"
          class="big w-100"
          @click="changeRoute('cadastro-google-ads')"
        />

        <div class="help">
          <p>Tem dúvidas? Acesse&nbsp;</p>
          <a
            href="https://ajuda.easydelivery.com.br/"
            target="_blank"
            class="link"
            >https://ajuda.easydelivery.com.br/</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/veasy/integrations.css';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';

export default {
  components: {
    BaseTitle,
    BaseButton,
  },
  methods: {
    changeRoute(routeName) {
      this.$router.push({ name: routeName });
    },
  },
};
</script>
